import { Button, EmptyState, Page, PageHeader } from '@platform/design-system';
import { RouterLink } from '@platform/app-kit';

export function NotFoundPage() {
  return (
    <Page>
      <PageHeader title="Page not found" />
      <EmptyState
        title="There's nothing at this address"
        description="The link may be old, or the page may have moved."
        action={
          <Button component={RouterLink} href="/tenants" variant="contained">
            Back to tenants
          </Button>
        }
      />
    </Page>
  );
}
